<div class="content">
  <app-toolbar-alerts *ngIf="status" [status]="status" [alertMessage]="alertMessage" (alertClosed)="alertMessage = ''"></app-toolbar-alerts>
  <div class="reset-form">
    <h2>Cambiar contraseña</h2>
    <form class="inputs" [formGroup]="resetPasswordForm" novalidate (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" color="primary">
        <mat-label color="accent">Nueva contraseña</mat-label>
        <input matInput formControlName="newPassword" #password type="password" />
        <mat-error *ngIf="!resetPasswordForm.get('newPassword')?.valid">Introduce una contraseña válida</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" color="primary">
        <mat-label color="accent">Vuelve a escribir la nueva contraseña</mat-label>
        <input matInput formControlName="repeatNewPassword" #password type="password" />
        <mat-error *ngIf="
                  resetPasswordForm.get('repeatNewPassword')?.value !==
                  resetPasswordForm.get('newPassword')?.value
                ">Las contraseñas tienen que coincidir</mat-error>
      </mat-form-field>
    </form>
    <div class="buttons">
      <button class="main-dark-button" (click)="onSubmit()" aria-label="register_btn" type="submit"
        [disabled]="!resetPasswordForm?.valid">
        <p>Enviar</p>
      </button>
    </div>
  </div>
</div>